import { ImageBlock } from '../blocks/ImageBlock';
import { VideoBlock } from '../blocks/VideoBlock';
export var customBlockRenderer = function customBlockRenderer(contentBlock, editorState) {
  if (contentBlock.getType() === 'atomic') {
    var contentState = editorState.getCurrentContent();
    var entity = contentState.getEntity(contentBlock.getEntityAt(0));
    var type = entity.getType();
    if (type === 'image') {
      return {
        component: ImageBlock,
        editable: false
      };
    }
    if (type === 'video') {
      var _entity$getData = entity.getData(),
        src = _entity$getData.src;
      return {
        component: VideoBlock,
        editable: false,
        props: {
          src: src
        }
      };
    }
  }
};